import * as React from 'react';
import {
  AutoSizer,
  IndexRange,
  InfiniteLoader,
  InfiniteLoaderChildProps,
  InfiniteLoaderProps,
  List,
  ListRowRenderer,
} from 'react-virtualized';
import { ISizer } from '../../../data/types';

interface IProps {
  rowHeight: number;
  rowRenderer: ListRowRenderer;
  data: unknown[];
  styles?: React.CSSProperties;
  onMore: (obj: IndexRange) => Promise<void>;
}

export const InfiniteList = (props: IProps): React.ReactElement => {
  const isRowLoaded = ({ index }: { index: number }): boolean => {
    return !!props.data[index];
  };

  return (
    <InfiniteLoader
      isRowLoaded={isRowLoaded}
      loadMoreRows={props.onMore}
      rowCount={1000000}
    >
      {({
        onRowsRendered,
        registerChild,
      }: InfiniteLoaderChildProps): React.ReactElement => (
        <AutoSizer>
          {(size: ISizer): React.ReactElement => {
            const { width, height } = size;
            return (
              <List
                style={{ outline: 'none', ...props.styles }}
                height={height}
                width={width}
                rowHeight={props.rowHeight}
                rowCount={props.data.length}
                rowRenderer={props.rowRenderer}
                onRowsRendered={onRowsRendered}
                ref={registerChild}
              />
            );
          }}
        </AutoSizer>
      )}
    </InfiniteLoader>
  );
};
